import { h, render } from 'preact';
import Beans3 from '@/beans';
import { riperStorage } from '@/base/helpers';
import Desktop from './views/Desktop';
import Mobile from './views/Mobile';
import EventBus from './helpers/utils/bus';
import ECMStorage from './helpers/utils/ECMStorage';

const Snow = {
  _domRender: null,
  _component: null,
  _ecmStorage: new ECMStorage(sessionStorage, 'ectomycorrhiza'),
  _bus: EventBus,
  _setContainers() {
    return new Promise(function (resolve) {
      const action = () => resolve(Beans3._utils.getOrCreateContainer(document.body, 'beans-snow-widget'));
      document.body ? action() : document.addEventListener('DOMContentLoaded', action);
    });
  },
  init({ riperDisplay }) {
    const display = riperDisplay.widget;
    /** No widget on checkout page */
    if (riperStorage.currentPage === 'checkout') return;
    if (!display.is_active && !Beans3.previewSession.isActive()) return;

    this._setContainers().then((container) => {
      /** Display widget */
      const Renderer = Beans3._utils.isMobile() ? Mobile : Desktop;
      const setComponent = (component) => (this._component = component);
      this._domRender = render(
        <Renderer display={display} setComponent={setComponent} ecmStorage={this._ecmStorage} bus={this._bus} />,
        container
      );

      /** Let all the others app know that Snow is ready to pump it up */
      Beans3._requirement.set('snow');
    });
  },
  toast(ecm) {
    this._component.addEcm(ecm);
  },
  listen(uid, action) {
    this._bus.on(uid, action);
  },
  delete(id) {
    this._component.removeEcm(id);
  },
};

export default Snow;
